import React from "react";

function Operations() {
  return <div></div>;
}

export default Operations;
